﻿import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User, UserRequest } from '../model';
import { EditProfileModel } from '../model/editProfileModel';
import { PasswordModel } from '../model/passwordModel';

@Injectable({ providedIn: 'root' })
export class UserService {
  apiUrl = environment.serverUrl;
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(this.apiUrl+`/users`);
    }

    register(user: User) {
        return this.http.post(this.apiUrl+`/users/register`, user);
    }

    delete(id: number) {
        return this.http.delete(this.apiUrl+`/users/${id}`);
    }
    findUser(email:string){
        return this.http.get<UserRequest>(`${this.apiUrl}/user/${email}`);
    }
    changePassword(passwordModel:PasswordModel):Observable<any>{
        return this.http.post<PasswordModel>(`${this.apiUrl}/user/changePassword`,passwordModel);
    }
    update(editProfileModel:EditProfileModel,id:number):Observable<any>{
        return this.http.post(`${this.apiUrl}/user/update/${id}`,editProfileModel);
    }
    findUserById(id:number){
        return this.http.get<any>(`${this.apiUrl}/user/profile/${id}`);
    }
}